import Skeleton from '../Skeleton.jsx';

/** Matches {@link ChatInput} chrome (placeholder row + footer toolbar). */
const ChatPanelComposerSkeleton = () => (
  <div className="w-full shrink-0 overflow-hidden rounded-xl border border-edge bg-surface-muted dark:bg-surface-muted">
    <div className="flex min-h-[56px] items-start px-4 py-3">
      <Skeleton height={14} width="42%" borderRadius={4} />
    </div>
    <div className="flex min-h-12 items-center justify-between gap-4 border-t border-edge/60 px-4 py-2">
      <Skeleton height={24} width={24} borderRadius={6} />
      <Skeleton height={18} width={88} borderRadius={6} />
    </div>
  </div>
);

export default ChatPanelComposerSkeleton;
